import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { GetInvestigationTypeCategoriesResult } from './get-investigation-type-categories.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationTypeCategoriesUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(): Observable<GetInvestigationTypeCategoriesResult> {
    return this._repository.getCategories().pipe(
      tap((categories) => this._state.setCategories(categories)),
      map((categories) => ({ categories })),
      catchError((error) => {
        this._state.setError(
          error?.error?.message || error?.message || 'Failed to load categories',
        );
        throw error;
      }),
    );
  }
}
